<!-- Loading -->
<ngx-loading [show]="loading" [config]="{ backdropBorderRadius: '3px' }"></ngx-loading>

<!-- Error Section -->
<div *ngIf="error" class="w-full flex items-center justify-center">
    <app-error-page></app-error-page>
</div>

<!-- Booking Success Section -->
<!-- <div *ngIf="bookingSuccess && !error" class="w-full flex items-center justify-center">
    <app-booking-success [bookingdata]="bookingData.scheduledSession"
        [bookingduration]="bookingPage.accountSession.duration" [bookingSlotTime]="bookingSlotTime"
        [id]="bookingPage.accountSession.uuid" class="w-full flex">
    </app-booking-success>
</div> -->

<div *ngIf="bookingSuccess && !error" class="w-full flex items-center justify-center">
    <app-booking-success [data]="bookingSuccessInput" class="w-full flex">
    </app-booking-success>
</div>

<!-- Main Booking Section linear-->
<div class="w-full flex flex-col justify-center" *ngIf="!hideBooking">
    <div class="ml-3 mt-2 flex justify-between  text-secondary px-2 border-b" *ngIf="BookingView==='WEEK'">
        <h1 class="text-2xl font-semibold dark:text-white">
            {{bookingPage.accountSession.name}}
        </h1>

        <div class="mt-1 flex items-center space-x-2 text-secondary">
            <mat-icon class="text-primary icon-size-4 dark:text-primary-500" svgIcon="heroicons_outline:clock"
                matTooltip="Duration">
            </mat-icon>
            <span class="text-lg font-medium">
                {{bookingPage.accountSession.duration}} Minutes
            </span>
        </div>
    </div>
    <mat-stepper linear #stepper class="w-full grow  pb-6  no-select" [ngClass]="stepper?.selectedIndex==0  && BookingView =='WEEK'? 'bg-white' : 'bg-slate-100'">

        <div class="tabs-header">
            <!-- First Step : Slot Selection  -->
            <mat-step [stepControl]="slot_form" label="Booking Information" *ngIf="BookingView==='WEEK'">
                <form [formGroup]="slot_form">
                    <ng-template matStepContent>
                        <div style="min-height: 60vh;" class="flex border-gray-200 border rounded   lg:p-6 py-3 grow booking-step-1 flex-wrap md:flex-nowrap">

                            <!-- Card-2 Calendar Section -->
                            <div class="w-full md:w-2/12  bg-white rounded-md   mb-4 md:mb-0 md:ml-4">
                                <div class="flex border-b justify-between items-center ">
                                    <!-- <h2 class="text-md font-semibold text-primary-500  mb-0">Select a Date</h2> -->
                                    <div class="flex px-2 py-3 items-center">
                                        <mat-icon class="text-primary-500 dark:text-primary-500 icon-size-5"
                                            svgIcon="heroicons_outline:calendar" matTooltip="Select a date"></mat-icon>
                                        <div class="ml-3">
                                            <div *ngIf="selectedDate" class="text-primary">
                                                {{selectedDate | date: 'MMMM y'}}
                                            </div>
                                            <div *ngIf="!selectedDate" class="text-red-400">
                                                Please select a date
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="flex justify-center items-center transform ">
                                    <div class="cal-picker">
                                        <ngb-datepicker #dp formControlName="calenderSelectedDate" [minDate]="minDate"
                                            [maxDate]="maxDate" (dateSelect)="onDateSelect()"></ngb-datepicker>
                                    </div>

                                </div>
                                <div class="align-center items-center mt-4">
                                        <div class="font-medium leading-6 text-primary">
                                            Time Zone
                                        </div>
                                        <div class="mt-0.5 text-secondary border-2 rounded-lg">
                                            <mat-select [(value)]="selectedTimeZone" disableOptionCentering class="px-1"
                                                (selectionChange)="onDateSelect()">
                                                <mat-option *ngFor="let tz of timeZones" [value]="tz">
                                                    {{ tz.label }}
                                                </mat-option>
                                            </mat-select>
                                        </div>
                                    </div>

                            </div>

                            <!-- Card-3 Time Slots Section -->
                            <div class="w-full md:w-10/12  bg-white  md:ml-4">
                               
                                <div *ngIf="timeSlotsUI.length && !loading"
                                    class="flex justify-between items-center border-b animate-in fade-in duration-500">
                                    <div *ngIf="!allBooked" class="flex items-center justify-between w-full ">
                                        <h2 class="text-md font-semibold text-primary-500">Select Booking Slot</h2>
                                        <div class="flex px-2 py-3 items-center">
                                            <mat-icon class="text-primary dark:text-primary-500 icon-size-5"
                                                svgIcon="heroicons_outline:clock"></mat-icon>
                                            <div class="ml-3 flex align-center items-center">
                                                <div *ngIf="selectedSlot?.time" class="text-primary">
                                                    {{selectedSlot?.localUtcDate| date:'MM-dd-yyyy':'UTC' }} 
                                                    {{selectedSlot?.localUtcDate| date:'hh:mm aa':'UTC' }} 
                                                </div>
                                                <div *ngIf="!selectedSlot?.time && !allBooked" class="text-red-500">
                                                    Select a time
                                                </div>

                                            </div>
                                        </div>
                                    </div>

                                    <fuse-alert *ngIf="allBooked && !loading" [type]="'warn'" [appearance]="'outline'"
                                        class="drop-shadow select-none w-full my-3">
                                        <b>Info: </b> All Slots Booked
                                    </fuse-alert>
                                </div>

                                <fuse-alert *ngIf="!timeSlotsUI.length && !loading" [type]="'warn'"
                                    [appearance]="'outline'" class="drop-shadow select-none my-3">
                                    <b>Info: </b> No slots available
                                </fuse-alert>

                                <div class=" relative flex  date-picker-time justify-evenly gap-2  flex-row   py-2"
                                    *ngIf="selectedDate && !loading">
                                    <div (click)="onDateSelect('prev')" style="left: 0; top: 16px;" class="absolute  group inline-block">
                                        <!-- Tooltip -->
                                        <div class="absolute bottom-full mb-2 hidden group-hover:block bg-gray-800 text-white text-sm rounded px-2 py-1 whitespace-nowrap">
                                          Previous Week
                                        </div>
                                      
                                        <!-- Circular button -->
                                        <button class="w-10 h-10 rounded-full bg-gray-100 hover:bg-gray-200 flex items-center justify-center shadow">
                                          <svg class="w-4 h-4 text-gray-700" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                                            <path stroke-linecap="round" stroke-linejoin="round" d="M15 19l-7-7 7-7" />
                                          </svg>
                                        </button>
                                      </div>
                                      <div style="right: 0; top: 16px;" class="absolute group inline-block">
                                        <!-- Tooltip -->
                                        <div class="absolute bottom-full mb-2 hidden group-hover:block bg-gray-800 text-white text-sm rounded px-2 py-1 whitespace-nowrap">
                                          Next Week
                                        </div>
                                      
                                        <!-- Circular button -->
                                        <button (click)="onDateSelect('next')" class="w-10 h-10 rounded-full bg-gray-100 hover:bg-gray-200 flex items-center justify-center shadow">
                                          <svg class="w-4 h-4 text-gray-700" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                                            <path stroke-linecap="round" stroke-linejoin="round" d="M9 5l7 7-7 7" />
                                          </svg>
                                        </button>
                                      </div>
                                    <div *ngFor="let ws of this.timeSlotsUI; let i = index"
                                        class="flex items-center  flex-col time-slots-column  grow  max-w-32">
                                        <div
                                        [matTooltip]="ws.date | date"
                                            class="w-10 h-10 border-primary-500 rounded-full text-dark border flex p-6 mt-2 items-center justify-center">
                                            <div class="text-center leading-tight">
                                                <div class="text-xs">{{ws.day}}</div>
                                                <div class="text-lg font-semibold">{{ws.dateDay}}</div>
                                            </div>
                                        </div>
                                        <ng-container *ngFor="let slot of ws.slots; let i = index; let first = first"
                                            class="pt-12">
                                            <div class="flex justify-between pt-1  flex-col gap-2 w-full "
                                                [ngClass]="{ 'pt-6': first }">
                                                <button *ngIf="slot.time!='--'" type="button " (click)="onTimeSlotClick(slot)"
                                                    class="text-blue-700 hover:text-white border  border-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-full text-sm p-2 text-center me-2 mb-2 dark:border-blue-500 dark:text-blue-500 dark:hover:text-white dark:hover:bg-blue-500 dark:focus:ring-blue-800 whitespace-nowrap"
                                                    [ngClass]="{
                                                        'selected-slot': selectedSlot.uuid === slot.uuid,
                                                        'booked-slot': !slot.available,
                                                        'available-sl': slot.available && selectedSlot.uuid !== slot.uuid
                                                    }" [disabled]="!slot.available || selectedSlot.uuid === slot.uuid">
                                                    <span class="slot-text text-center justify-center">
                                                        <mat-icon *ngIf="!slot.available"
                                                            svgIcon="heroicons_outline:lock-closed"
                                                            class="icon-size-4"></mat-icon>
                                                        <mat-icon class="icon-size-4" *ngIf="selectedSlot.uuid === slot.uuid"
                                                            svgIcon="heroicons_outline:check-circle"></mat-icon>
                                                        {{ slot.time }}
                                                    </span>
                                                </button>
                                                <button *ngIf="slot.time=='--'" type="button " disabled
                                                class=""
                                              >
                                                <span class="slot-text  text-gray-400 text-center justify-center pb-4 mb-2">
                                                   __
                                                </span>
                                            </button>

                                                <button *ngIf="selectedSlot.uuid === slot.uuid" mat-raised-button
                                                    type="button"
                                                    class="text-white bg-green-700 hover:bg-green-800 focus:outline-none focus:ring-4 focus:ring-green-300 font-medium rounded-full text-sm px-5 py-2.5 text-center me-2 mb-2 dark:bg-green-600 dark:hover:bg-green-700 dark:focus:ring-green-800"
                                                    matTooltip="Go to next step" [color]="'primary'"
                                                    (click)="onNextClick(slot,stepper)">
                                                    <div class="flex  justify-center items-center">
                                                        <span class="d-flex items-center justify-center ">Next </span> 
                                                        <mat-icon class="icon-size-4 ml-2" *ngIf="selectedSlot.uuid === slot.uuid"
                                                            svgIcon="heroicons_outline:arrow-right"></mat-icon>
                                                        <!-- <mat-icon class="icon-size-3">arrow_forward</mat-icon> -->
                                                    </div>
                                                </button>
                                            </div>
                                        </ng-container>
                                        <div *ngIf="!timeSlotsUI.length && !loading">
                                            <ng-lottie class="flex justify-center" #lotani>
                                            </ng-lottie>
                                        </div>
                                    </div>
                                </div>

                            </div>


                        </div>
                    </ng-template>
                </form>
            </mat-step>

            <mat-step [stepControl]="slot_form" label="Booking Information" *ngIf="BookingView!=='WEEK'">
                <form [formGroup]="slot_form">
                    <ng-template matStepContent>
                        <div class="flex p-0 lg:p-6 grow booking-step-1 flex-wrap md:flex-nowrap">
                            <!-- Card-1 Details -->
                            <div class="w-full md:w-1/4 p-4 bg-white rounded-md shadow card-1 mb-4 md:mb-0">
                                <h2 class="text-lg font-semibold mb-0 py-3 border-b text-primary-500">Details</h2>
                                <div class="flex px-2 py-3 border-b items-center">
                                    <mat-icon class="text-primary dark:text-primary-500" svgIcon="heroicons_outline:users"
                                        matTooltip="Name"></mat-icon>
                                    <div class="ml-3">
                                        <div class="font-medium leading-6 text-primary">
                                            Booking
                                        </div>
                                        <div class="mt-0.5 text-secondary">
                                            {{bookingPage.accountSession.name}}
                                        </div>
                                    </div>
                                </div>
                                <div class="flex px-2 py-3 border-b align-center items-center">
                                    <mat-icon class="text-primary dark:text-primary-500" svgIcon="heroicons_outline:clock"
                                        matTooltip="Duration"></mat-icon>
                                    <div class="ml-3">
                                        <div class="font-medium leading-6 text-primary">
                                            Duration
                                        </div>
                                        <div class="mt-0.5 text-secondary">
                                            {{bookingPage.accountSession.duration}} Minutes
                                        </div>
                                    </div>
                                </div>
                                <div class="flex px-2 py-3 border-b align-center items-center">
                                    <mat-icon class="text-primary dark:text-primary-500" svgIcon="heroicons_outline:globe-alt"
                                        matTooltip="Time Zone"></mat-icon>
                                    <div class="ml-3 w-full">
                                        <div class="font-medium leading-6 text-primary">
                                            Time Zone
                                        </div>
                                        <div class="mt-0.5 text-secondary border-2 rounded-lg">
                                            <mat-select [(value)]="selectedTimeZone" disableOptionCentering class="px-1"
                                                (selectionChange)="onDateSelect()">
                                                <mat-option *ngFor="let tz of timeZones" [value]="tz">
                                                    {{ tz.label }}
                                                </mat-option>
                                            </mat-select>
                                        </div>
                                    </div>
                                </div>
                            </div>
    
                            <!-- Card-2 Calendar Section -->
                            <div class="w-full md:w-2/4 p-4 bg-white rounded-md shadow card-2 mb-4 md:mb-0 md:ml-4">
                                <div class="flex border-b justify-between items-center ">
                                    <h2 class="text-lg font-semibold text-primary-500  mb-0">Select a Date</h2>
                                    <div class="flex px-2 py-3 items-center">
                                        <mat-icon class="text-primary-500 dark:text-primary-500 icon-size-5"
                                            svgIcon="heroicons_outline:calendar" matTooltip="Select a date"></mat-icon>
                                        <div class="ml-3">
                                            <div *ngIf="selectedDate" class="text-primary text-secondary">
                                                {{selectedDate}}
                                            </div>
                                            <div *ngIf="!selectedDate" class="text-red-400">
                                                Please select a date
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="flex justify-center items-center transform ">
                                    <div class="cal-picker custom-calendar" >
                                        <ngb-datepicker formControlName="calenderSelectedDate" [minDate]="minDate"
                                            [maxDate]="maxDate" (dateSelect)="onDateSelect()"></ngb-datepicker>
                                    </div>
    
                                </div>
    
                            </div>
    
                            <!-- Card-3 Time Slots Section -->
                            <div class="w-full md:w-1/3 p-4 bg-white rounded-md shadow max-h-128 card-3 md:ml-4">
                                <div *ngIf="timeSlotsUI.length && !loading"
                                    class="flex justify-between items-center border-b animate-in fade-in duration-500">
                                    <div *ngIf="!allBooked" class="flex items-center justify-between w-full ">
                                        <h2 class="text-lg font-semibold text-primary-500">Select Time</h2>
                                        <div class="flex px-2 py-3 items-center">
                                            <mat-icon class="text-primary dark:text-primary-500 icon-size-5"
                                                svgIcon="heroicons_outline:clock"></mat-icon>
                                            <div class="ml-3 flex align-center items-center">
                                                <div *ngIf="selectedSlot?.time" class="text-primary">
                                                    {{selectedSlot?.time}}
                                                </div>
                                                <div *ngIf="!selectedSlot?.time && !allBooked" class="text-red-500">
                                                    Select a time
                                                </div>
    
                                            </div>
                                        </div>
                                    </div>
    
                                    <fuse-alert *ngIf="allBooked && !loading" [type]="'warn'" [appearance]="'outline'"
                                        class="drop-shadow select-none w-full my-3">
                                        <b>Info: </b> All Slots Booked
                                    </fuse-alert>
                                </div>

                                <div class="date-picker-time" *ngIf="selectedDate && !loading">
                                    <div *ngIf="timeSlotsUI[0].slots.length; else elseBlock" class="flex flex-col time-slots-column pb-8 overflow-y-auto max-h-64 md:max-h-96">
                                        <ng-container *ngFor="let slot of timeSlotsUI[0].slots; let i = index">
                                            <div class="flex justify-between gap-2 w-full">
                                                <button type="button" (click)="onTimeSlotClick(slot)"
                                                    class="fuse-mat-button-small w-full mt-2 time-slot-btn" mat-raised-button
                                                    [ngClass]="{
                                                            'selected-slot': selectedSlot.uuid === slot.uuid,
                                                            'booked-slot': !slot.available,
                                                            'available-slot': slot.available && selectedSlot.uuid !== slot.uuid
                                                        }"
                                                    [disabled]="!slot.available || selectedSlot.uuid === slot.uuid">
                                                    <span class="slot-text">
                                                        <mat-icon *ngIf="!slot.available"
                                                            svgIcon="heroicons_outline:lock-closed"
                                                            class="icon-size-4"></mat-icon>
                                                        <mat-icon *ngIf="selectedSlot.uuid === slot.uuid"
                                                            svgIcon="heroicons_outline:check-circle"></mat-icon>
                                                            {{slot.localUtcDate | date:'hh:mm aa':'UTC' }}
                                                    </span>
                                                </button>
                                                <button *ngIf="selectedSlot.uuid === slot.uuid" mat-raised-button
                                                    type="button" class="fuse-mat-button-small w-1/2 mt-2 px-1 bg-green-500"
                                                    matTooltip="Go to next step" [color]="'primary'"
                                                    (click)="onNextClick(slot,stepper)">
                                                    <div class="flex gap-2 justify-center items-center">
                                                        <span>Next</span>
                                                        <mat-icon class="icon-size-4">arrow_forward</mat-icon>
                                                    </div>
                                                </button>
                                            </div>
                                        </ng-container>
                                        <div *ngIf="!timeSlotsUI.length && !loading">
                                            <ng-lottie class="flex justify-center" #lotani >
                                            </ng-lottie>
                                        </div>
                                    </div>
                                    <ng-template #elseBlock>
                                        <fuse-alert *ngIf="!loading" [type]="'warn'" [appearance]="'outline'"
                                        class="drop-shadow select-none my-3">
                                        <b>Info: </b> No slots available
                                    </fuse-alert>
                                      </ng-template>
                                </div>
    
                            </div>
                        </div>
                    </ng-template>
                </form>
            </mat-step>

            <!-- Second Step : Client Details -->
            <mat-step [stepControl]="personal_details_form">
                <ng-template matStepLabel>
                    Personal Details
                </ng-template>
                <ng-template matStepContent>
                    <div class="flex flex-col lg:flex-row bg-white border rounded-lg p-6 shadow-md">
                        <div class="lg:w-1/2 pr-4 md:border-r">
                            <h2 class="text-lg font-bold text-blue-600 md:mb-4 border-b">
                                {{bookingPage.accountSession.name}}
                            </h2>
                            <div class="flex px-2 py-3 border-b items-center">
                                <mat-icon class="text-primary dark:text-primary-500" svgIcon="heroicons_outline:clock"
                                    matTooltip="Duration"></mat-icon>
                                <div class="ml-3">
                                    <div class="font-medium leading-6 text-primary">
                                        Appointment Duration
                                    </div>
                                    <div class="mt-0.5 text-secondary">
                                        {{bookingPage.accountSession.duration}} Minutes
                                    </div>
                                </div>
                            </div>

                            <div class="flex px-2 py-3 border-b items-center">
                                <mat-icon class="text-primary dark:text-primary-500"
                                    svgIcon="heroicons_outline:calendar" matTooltip="Date"></mat-icon>
                                <div class="ml-3">
                                    <div class="font-medium leading-6 text-primary">
                                        Date
                                    </div>
                                    <div class="mt-0.5 text-secondary">
                                        {{selectedSlot.UtcDate | date:'MM-dd-yyyy':'UTC' }}
                                    </div>
                                </div>
                            </div>

                            <!-- Booking Time -->
                            <div class="flex px-2 py-3 border-b items-center">
                                <mat-icon class="text-primary dark:text-primary-500" svgIcon="heroicons_outline:clock"
                                    matTooltip="Time"></mat-icon>
                                <div class="ml-3">
                                    <div class="font-medium leading-6 text-primary">
                                        Booking Time
                                    </div>
                                    <div class="mt-0.5 text-secondary">
                                        {{selectedSlot.time}}
                                    </div>
                                </div>
                            </div>

                        </div>

                        <!-- Right Section: Form -->
                        <div class="lg:w-1/2 lg:pl-4 lg:mt-0 mt-6">
                            <h2 class="text-lg font-bold text-blue-600 border-b mb-4">Enter Details</h2>
                            <form #personal_form="ngForm" [formGroup]="personal_details_form" class="space-y-1">

                                <!--Client First Name -->
                                <div class="flex w-full gap-2">
                                    <mat-form-field appearance="fill" class="w-1/2">
                                        <mat-label>First Name</mat-label>
                                        <input formControlName="clientFirstName" matInput type="text" name="client_first_name" required
                                         />
                                        <mat-error>First Name is required.</mat-error>
                                    </mat-form-field>
                                
                                    <!--Client Last Name -->
                                    <mat-form-field appearance="fill" class="w-1/2">
                                        <mat-label>Last Name</mat-label>
                                        <input formControlName="clientLastName" matInput type="text" name="client_last_name" required
                                            [(ngModel)]="bookingData.scheduledSession.client_last_name"  />
                                        <mat-error>Last Name is required.</mat-error>
                                    </mat-form-field>
                                </div>

                                <!-- Email -->
                                <div class="flex w-full gap-2">
                                    <mat-form-field appearance="fill" class="w-1/2 email-picker">
                                        <mat-label>Email</mat-label>
                                        <input formControlName="clientEmail" matInput type="email" name="client_email" required
                                            [(ngModel)]="bookingData.scheduledSession.client_email" />
                                        <mat-error>Valid email is required.</mat-error>
                                    </mat-form-field>
                                
                                    <!-- Phone No -->
                                    <div matFormField class="w-1/2 phone-picker">
                                        <mat-label style="font-weight: 500;">Phone *</mat-label>
                                        <ngx-intl-tel-input matInput [preferredCountries]="preferredCountries" [enableAutoCountrySelect]="true"
                                            [enablePlaceholder]="false" [searchCountryFlag]="true" [maxLength]="15" [phoneValidation]="true"
                                            [numberFormat]="PhoneNumberFormat.National" [searchCountryField]="[ SearchCountryField.All]"
                                            [selectFirstCountry]="false" [selectedCountryISO]="CountryISO.UnitedStates" [separateDialCode]="true"
                                            name="phone" formControlName="phone">
                                        </ngx-intl-tel-input>
                                
                                        <mat-error *ngIf="isInvalidPhoneNumber() && personal_form.submitted">
                                            <span class="text-sm phone-validation">Please enter valid phone
                                                number</span>
                                        </mat-error>
                                        <mat-error *ngIf="isEmptyPhoneNumber() && personal_form.submitted">
                                            <span class="text-sm phone-validation">Phone number is required</span>
                                        </mat-error>
                                    </div>
                                </div>

                                <!-- Notes -->
                                <mat-form-field appearance="fill" class="w-full">
                                    <mat-label>Reason for appointment</mat-label>
                                    <textarea formControlName="notes" matInput rows="2" name="notes"
                                       ></textarea>
                                </mat-form-field>
                            </form>
                        </div>
                    </div>
                </ng-template>
            </mat-step>

            <!-- Third Step : Questionnaire -->
            <mat-step *ngIf="this.bookingSteps.intake" [stepControl]="intake_form">
                <ng-template matStepLabel>Intake Questions</ng-template>
                <ng-template matStepContent>
                    <div class="p-4 mb-4 mt-4 text-sm text-blue-800 rounded-lg bg-primary-100 dark:bg-gray-800 dark:text-blue-400"
                        role="alert">
                        <span class="text-gray-600 ">
                            Please answer the following questions.
                        </span>
                    </div>
                    <div class="flex justify-center items-center">
                        <div class="w-full">
                            <dynamic-form #dynamicForm [definition]="definition" [model]="model" />
                        </div>
                        <!-- Hidden input field to enforce form validity -->
                        <form [formGroup]="intake_form" class="space-y-1" style="visibility: hidden;display: none;">
                            <input formControlName="validated">
                        </form>

                    </div>
                </ng-template>
            </mat-step>

            <!-- Fourth Step : Payment -->
            <mat-step *ngIf="this.bookingSteps.payment">
            
                <ng-template matStepLabel>Payment</ng-template>
            
                <ng-template matStepContent>
                    <app-cc-payment [paymentAmount]="this.bookingPage.accountSession.amount"
                        (onSuccess)="setPaymentDetails($event)">
                    </app-cc-payment>
                </ng-template>
            
            </mat-step>
        </div>

    </mat-stepper>
    <div class="flex gap-4 justify-between mb-3 px-3" *ngIf="stepper?.selectedIndex!=0">
        <button mat-raised-button color="warn" class="text-white" (click)="stepper?.previous()"
            *ngIf="(stepper?.selectedIndex!=0)">
            <div class="flex gap-2 justify-center items-center">
                <mat-icon class="icon-size-5">arrow_back</mat-icon>
                <span>Back</span>
            </div>
        </button>
        <button *ngIf="(stepper?.selectedIndex!=(bookingStepsCount-1))" (click)="goNext(stepper)" mat-raised-button
            color="primary" class=" text-white" type="submit">
            <div class="flex gap-2 justify-center items-center">
                <span>Next</span>
                <mat-icon class="icon-size-5">arrow_forward</mat-icon>
            </div>
        </button>

        <button mat-raised-button [disabled]="!isFormsValid() || loading" (click)="executeRecaptchaV3()"
            *ngIf="stepper?.selectedIndex==(bookingStepsCount-1)" color="primary" type="submit">

            @if(loading){
            <div class="flex gap-2 justify-center items-center">
                <span>Submitting</span>
                <mat-icon class="icon-size-5 animate-spin" [svgIcon]="'heroicons_solid:cog'"></mat-icon>
            </div>
            }@else {
            <div class="flex gap-2 justify-center items-center">
                <span>Submit</span>
                <mat-icon class="icon-size-5" [svgIcon]="'heroicons_outline:paper-airplane'"></mat-icon>
            </div>
            }

        </button>
    </div>
</div>